import React from "react";
import { Route } from "react-router-dom";

import NotasFiscaisEmitidasLayout from "../pages/Templates/Template-Administrativo/Financeiro/NotasFiscaisEmitidasLayout";
import RegrasFiscaisClientesLayout from "../pages/Templates/Template-Administrativo/Financeiro/RegrasFiscaisClientesLayout";
//import ContasReceberLayout from "../pages/Templates/Template-Administrativo/Financeiro/ContasReceberLayout";
//import ContasPagarLayout from "../pages/Templates/Template-Administrativo/Financeiro/ContasPagarLayout";
//import ConciliacaoBancariaLayout from "../pages/Templates/Template-Administrativo/Financeiro/ConciliacaoBancariaLayout";
//import ComprasFinanceiroLayout from "../pages/Templates/Template-Administrativo/Financeiro/ComprasFinanceiroLayout";
//import FluxoCaixaLayout from "../pages/Templates/Template-Administrativo/Financeiro/FluxoCaixaLayout";
//import InadimplenciaCobrancasLayout from "../pages/Templates/Template-Administrativo/Financeiro/InadimplenciaCobrancasLayout";
//import RetencoesTributosLayout from "../pages/Templates/Template-Administrativo/Financeiro/RetencoesTributosLayout";
//import ContratosRecorrenciasLayout from "../pages/Templates/Template-Administrativo/Financeiro/ContratosRecorrenciasLayout";
//import RelatoriosFinanceirosLayout from "../pages/Templates/Template-Administrativo/Financeiro/RelatoriosFinanceirosLayout";

export const financeiroRoutes = (
  <>
    {/*
      Rota: /financeiro/nfs
      Página: Notas fiscais emitidas
      Função:
      Controle operacional das NFS-e/NF-e emitidas, incluindo situação fiscal,
      PDF/XML, envio ao cliente, vínculo com conta a receber, histórico,
      cancelamento, substituição e conferência documental.
    */}
    <Route path="/financeiro/nfs" element={<NotasFiscaisEmitidasLayout />} />

    {/*
      Rota: /financeiro/regras-fiscais
      Página: Regras fiscais por cliente
      Função:
      Cadastro das orientações fiscais e operacionais de cada cliente,
      indicando se exige SC, PI, PO, pedido de compra, portal, dados
      complementares, agrupamento de serviços, contatos fiscais e forma
      correta de envio da nota.
    */}
    <Route
      path="/financeiro/regras-fiscais"
      element={<RegrasFiscaisClientesLayout />}
    />

    {/*
      Rota: /financeiro/contas-a-receber
      Página: Contas a receber
      Função:
      Controle de títulos a receber, vencimentos, recebimentos, parcelas,
      valores em aberto, recebimentos parciais, inadimplência, baixa financeira
      e vínculo com notas fiscais emitidas.
  
    <Route
      path="/financeiro/contas-a-receber"
      element={<ContasReceberLayout />}
    /> */}

    {/*
      Rota: /financeiro/contas-a-pagar
      Página: Contas a pagar
      Função:
      Controle de obrigações financeiras da empresa, incluindo fornecedores,
      boletos, vencimentos, comprovantes, notas fiscais de compra, aprovações,
      pagamentos realizados e pendências documentais.
   
    <Route path="/financeiro/contas-a-pagar" element={<ContasPagarLayout />} /> */}

    {/*
      Rota: /financeiro/conciliacao-bancaria
      Página: Conciliação bancária
      Função:
      Conferência entre extratos bancários e lançamentos internos do sistema,
      validando se pagamentos, recebimentos, tarifas, transferências e entradas
      foram corretamente conciliados.
   
    <Route
      path="/financeiro/conciliacao-bancaria"
      element={<ConciliacaoBancariaLayout />}
    /> */}

    {/*
      Rota: /financeiro/compras
      Página: Compras financeiras
      Função:
      Controle financeiro das compras realizadas, com vínculo a fornecedor,
      nota fiscal de compra, comprovante de pagamento, centro de custo,
      categoria, aprovação interna e situação documental.

    <Route path="/financeiro/compras" element={<ComprasFinanceiroLayout />} /> */}

    {/*
      Rota: /financeiro/fluxo-de-caixa
      Página: Fluxo de caixa
      Função:
      Previsão diária, semanal e mensal das entradas e saídas financeiras,
      permitindo acompanhar saldo projetado, recebíveis futuros, contas a pagar,
      recorrências e movimentações previstas.

    <Route path="/financeiro/fluxo-de-caixa" element={<FluxoCaixaLayout />} /> */}

    {/*
      Rota: /financeiro/cobrancas
      Página: Cobranças
      Função:
      Controle de inadimplência, lembretes de cobrança, follow-up com clientes,
      histórico de contatos, títulos vencidos, próximos vencimentos e ações
      pendentes de cobrança.
 
    <Route
      path="/financeiro/cobrancas"
      element={<InadimplenciaCobrancasLayout />} 
    /> */}

    {/*
      Rota: /financeiro/retencoes-e-tributos
      Página: Retenções e tributos
      Função:
      Controle de ISS, IRRF, PIS, COFINS, CSLL, INSS, DAS, guias e retenções
      vinculadas às notas fiscais, identificando valor bruto, valor líquido,
      responsável pelo recolhimento e status da obrigação tributária.

    <Route
      path="/financeiro/retencoes-e-tributos"
      element={<RetencoesTributosLayout />}
    /> */}

    {/*
      Rota: /financeiro/contratos-recorrencias
      Página: Contratos e recorrências
      Função:
      Gestão de contratos recorrentes, mensalidades, licenças de software,
      contratos de suporte, serviços continuados, geração prevista de notas,
      geração de recebíveis e controle de vigência.
 
    <Route
      path="/financeiro/contratos-recorrencias"
      element={<ContratosRecorrenciasLayout />}
    /> */}

    {/*
      Rota: /financeiro/relatorios
      Página: Relatórios financeiros
      Função:
      Relatórios de faturamento, contas a pagar, contas a receber, DRE gerencial,
      margem, centro de custo, inadimplência, fluxo de caixa, tributos e
      exportações financeiras para análise interna.

    <Route
      path="/financeiro/relatorios"
      element={<RelatoriosFinanceirosLayout />}
    /> */}
  </>
);
